module.exports = __webpack_public_path__ + "img/not-found.af950d05.svg";